<template>
  <a-modal
    title="新增免单活动"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    :footer="false"
  >
    <a-spin :spinning="confirmLoading">
      <div class="goods-container">
        <div style="margin-bottom:10px;" v-for="(item,index) in goodslist" :key="index">
          <goods-card class="goods-card" :goodsinfo="item">
            <template v-slot:fd>
              <div class="goods-delete-btn" @click="handleDeleteGoods(index)">删除</div>
            </template>
          </goods-card>
        </div>
      </div>
      <div class="btn-container">
        <a-button type="primary" style="width: 50%" @click="$refs.goodslistModal.show()">
          <a-icon type="plus" />添加商品
        </a-button>
      </div>
      <a-divider orientation="left">设置</a-divider>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item label="电商平台" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input read-only :value="platform | goodsPlatform" />
        </a-form-item>
        <a-form-item label="有效日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-range-picker
            format="YYYY-MM-DD HH:mm"
            v-decorator="['range-picker', {rules: [{ type: 'array', required: true, message: '请选择时间' }]}]"
          />
        </a-form-item>
        <a-form-item label="免单总数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            placeholder="请输入"
            v-decorator="['total_free', {rules: [{required: true, message: '必填项' }]}]"
          />
        </a-form-item>
        <a-form-item label="每人限购" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            placeholder="请输入"
            v-decorator="['peer_limit', {rules: [{required: true, message: '必填项' }]}]"
          />
        </a-form-item>
        <a-form-item label="使用副联盟" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            placeholder="请选择"
            v-decorator="['use_sub_union', {initialValue:'0',rules: [{required: true, message: '必填项' }, { validator: this.handleSubunionCheck }]}]"
          >
            <a-select-option value="0">不使用</a-select-option>
            <a-select-option value="1">使用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="返利类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            placeholder="请选择"
            v-decorator="['rebate_type', {rules: [{required: true, message: '必填项' }]}]"
          >
            <a-select-option value="1">付款金额</a-select-option>
            <a-select-option value="2">自定义金额</a-select-option>
          </a-select>
        </a-form-item>
        <div :style="{display:'none'}">
          <a-form-item label="佣金比例" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number
              placeholder="请输入"
              v-decorator="['rebate_percent', {initialValue:'0',rules: [{message: '必填项' }]}]"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')"
            />
          </a-form-item>
        </div>
        <div v-show="formData['rebate_type'] == '2'">
          <a-form-item label="自定义金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number
              placeholder="请输入"
              v-decorator="['rebate_cash', {initialValue:'0',rules: [{required: formData['rebate_type'] == '2', message: '必填项' }]}]"
              :formatter="value => `${value}元`"
              :parser="value => value.replace('元', '')"
            />
          </a-form-item>
        </div>
        <a-form-item label="参与分组" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            mode="tags"
            placeholder="请选择"
            v-decorator="['use_group', {rules: [{required: true, message: '必填项' }]}]"
          >
            <a-select-option v-for="(item) in groups" :key="item.id">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :wrapper-col="{sm:  { span: 16, offset: 7 }}">
          <a-button :loading="confirmLoading" type="primary" htmlType="submit">保存</a-button>
        </a-form-item>
      </a-form>
    </a-spin>
    <goodslist-modal ref="goodslistModal" @ok="handleAddGoods"></goodslist-modal>
  </a-modal>
</template>

<script>
import ActivityApi from '@/api/activity'
import GoodslistModal from './GoodslistModal'
import GoodsCard from '@/views/activity/components/GoodsCard'
import { setTimeout } from 'timers';
import { constants } from 'crypto';
import FansApi from '@/api/fans'
export default {
  components: {
    GoodslistModal,
    GoodsCard
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this, {
        onValuesChange: (_, values) => {
          Object.assign(this.formData, values)
        }
      }),
      platform: null, //1：淘宝 2：京东 3：拼多多
      goodslist: [],
      formData: {},
      currentRobotId: null,
      groups: []
    }
  },
  filters: {
    goodsPlatform(str) {
      if (str == 1) {
        return '淘宝'
      } else if (str == 2) {
        return '京东'
      } else if (str == 3) {
        return '拼多多'
      } else {
        return '请添加商品'
      }
    }
  },
  watch: {
    goodslist(newVal) {
      if (newVal.length > 0) {
        this.platform = newVal[0].item_type
      } else {
        this.platform = null
      }
    }
  },
  methods: {
    show(currentRobotId) {
      this.currentRobotId = currentRobotId
      this.visible = true
      this.getGroup()
    },
    getGroup() {
      FansApi.getGroupList({ sub_id: this.currentRobotId }).then(res => {
        this.groups = res.data.map(item=>{
          return {
            id: item.id.toString(),
            name: item.name
          }
        })
        this.form.setFieldsValue({
          use_group: this.groups.map((item)=>{
            return item.id
          })
        })
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleAddGoods(goodsinfo) {
      if (this.platform && this.platform != goodsinfo.item_type) {
        this.$message.error('每个活动只能添加同一电商平台的商品')
        return false
      }
      this.goodslist.push(goodsinfo)
    },
    handleDeleteGoods(index) {
      this.goodslist.splice(index, 1)
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const group = this.groups.filter((item)=>{
            return values.use_group.includes(item.id)
          })
          const rangePicker = values['range-picker']
          const data = {
            sub_id: this.currentRobotId,
            start_time: rangePicker[0].format('YYYY-MM-DD HH:mm'),
            end_time: rangePicker[1].format('YYYY-MM-DD HH:mm'),
            item_info: JSON.stringify(this.goodslist),
            total_free: values['total_free'],
            peer_limit: values['peer_limit'],
            use_sub_union: values['use_sub_union'],
            rebate_type: values['rebate_type'],
            rebate_percent: values['rebate_percent'],
            rebate_cash: values['rebate_cash'],
            group: JSON.stringify(group)
          }
          this.confirmLoading = true
          ActivityApi.saveActivity(data)
            .then(res => {
              if (res.code === 1) {
                this.$message.success('操作成功')
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    handleSubunionCheck(rule, value, callback) {
      const platform = this.platform
      if (value == '1') {
        if (platform != 1) {
          callback(new Error('只有淘宝活动可以使用副联盟'))
        }
      }
      callback()
    }
  }
}
</script>
<style lang="less" scoped>
.goods-container {
  display: flex;
  flex-direction: column;
  .goods-card {
    .goods-delete-btn {
      line-height: 64px;
      width: 50px;
      color: #f5222d;
      display: none;
    }
  }
  .goods-card:hover {
    .goods-delete-btn {
      display: flex;
    }
  }
}
.btn-container {
  text-align: center;
  padding: 10px;
}
</style>
